import { render, staticRenderFns } from "./SetConversationName.vue?vue&type=template&id=0ba3ede8&scoped=true&"
import script from "./SetConversationName.vue?vue&type=script&lang=js&"
export * from "./SetConversationName.vue?vue&type=script&lang=js&"
import style0 from "./SetConversationName.vue?vue&type=style&index=0&id=0ba3ede8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba3ede8",
  null
  
)

export default component.exports